import { DriverMessage } from "./types";

export const mockDriverMessages: DriverMessage[] = [
  {
    id: "1",
    status: "Sent",
    title: "Demand Alert - Miami",
    content: "High demand expected in Miami downtown area. Surge pricing active.",
    createdAt: "16 December 2025, 16:22",
    lastUpdated: "16 December 2025, 16:22",
    sentAt: "16 December 2025, 16:22",
    recipientCount: 45
  },
  {
    id: "2",
    status: "Sent",
    title: "Reservation Available for Today!",
    content: "We have reservation requests available. Check your app for details.",
    createdAt: "16 December 2025, 16:14",
    lastUpdated: "16 December 2025, 16:14",
    sentAt: "16 December 2025, 16:14",
    recipientCount: 120
  },
  {
    id: "3",
    status: "Sent",
    title: "Demand Alert - Austin",
    content: "High demand in Austin downtown. Additional drivers needed.",
    createdAt: "16 December 2025, 16:10",
    lastUpdated: "16 December 2025, 16:10",
    sentAt: "16 December 2025, 16:10",
    recipientCount: 38
  },
  {
    id: "4",
    status: "Sent",
    title: "Demand Alert - Phoenix",
    content: "Increased ride requests in Phoenix airport area.",
    createdAt: "16 December 2025, 16:04",
    lastUpdated: "16 December 2025, 16:04",
    sentAt: "16 December 2025, 16:04",
    recipientCount: 52
  },
  {
    id: "5",
    status: "Sent",
    title: "Demand Alert - Seattle",
    content: "High demand expected in Seattle downtown. Please stay online.",
    createdAt: "16 December 2025, 16:04",
    lastUpdated: "16 December 2025, 16:04",
    sentAt: "16 December 2025, 16:04",
    recipientCount: 67
  },
  {
    id: "6",
    status: "Sent",
    title: "Demand Alert - Portland",
    content: "Surge pricing active in Portland city center.",
    createdAt: "16 December 2025, 15:52",
    lastUpdated: "16 December 2025, 15:52",
    sentAt: "16 December 2025, 15:52",
    recipientCount: 41
  },
  {
    id: "7",
    status: "Sent",
    title: "Your 13:45 Ride is coming up",
    content: "Reminder: You have a scheduled pickup at 13:45.",
    createdAt: "16 December 2025, 15:40",
    lastUpdated: "16 December 2025, 15:40",
    sentAt: "16 December 2025, 15:40",
    recipientCount: 1
  },
  {
    id: "8",
    status: "Sent",
    title: "High Demand Alert - San Diego",
    content: "High demand in Gaslamp Quarter area.",
    createdAt: "16 December 2025, 15:29",
    lastUpdated: "16 December 2025, 15:29",
    sentAt: "16 December 2025, 15:29",
    recipientCount: 33
  },
  {
    id: "9",
    status: "Sent",
    title: "Important: Driver Incentive Program Update",
    content: "New driver incentive program launching next week. Check your dashboard for details.",
    createdAt: "16 December 2025, 15:29",
    lastUpdated: "16 December 2025, 15:29",
    sentAt: "16 December 2025, 15:29",
    recipientCount: 250
  },
  {
    id: "10",
    status: "Sent",
    title: "Surge pricing!",
    content: "Surge pricing is now active in multiple zones.",
    createdAt: "16 December 2025, 15:28",
    lastUpdated: "16 December 2025, 15:28",
    sentAt: "16 December 2025, 15:28",
    recipientCount: 180
  },
  {
    id: "11",
    status: "Sent",
    title: "Demand Alert - Boston",
    content: "High demand near Boston Common area.",
    createdAt: "16 December 2025, 15:13",
    lastUpdated: "16 December 2025, 15:13",
    sentAt: "16 December 2025, 15:13",
    recipientCount: 29
  }
];